import React from 'react';

export default (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M21 12H10" strokeLinecap="round" />
    <path
      d="M13 8L9.70711 11.2929C9.31658 11.6834 9.31658 12.3166 9.70711 12.7071L13 16"
      strokeLinecap="round"
    />
    <path d="M9 3H7C4.79086 3 3 4.79086 3 7V17C3 19.2091 4.79086 21 7 21H9" strokeLinecap="round" />
  </svg>
);
